<template>
  <div class="images">
    <!-- swiper1 -->
    <div class="mac" @click="detail" @mouseenter="show_big_button=true" @mouseleave="show_big_button=false">
      <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
        <swiper-slide
          v-for="(item,i) in images"
          :key="i"
        >
        <img :src="item.img" class="img">
        </swiper-slide>
      </swiper>
      <div class="phone"></div>
      <div class="show_big" v-show="show_big_button">
        <img src="//txwl.huohuoche.com/txws/new_images_one/zhzx/show_big.png" />
      </div>
    </div>
    <div class="center_text">
      <p>热门{{images[index].title+(Number(images[index].id)+1)}}</p>
    </div>
    <!-- swiper2 Thumbs -->
    <!-- <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
      <swiper-slide
        v-for="(item,i) in images"
        :key="i"
        :style="{backgroundImage:'url('+item.img+')'}"
      ></swiper-slide>
    </swiper>-->
    <!-- 箭头放在外面 -->
    <div class="swiper-button-next swiper-button-white swiper-button-next-false1" slot="button-next"></div>
    <div class="swiper-button-prev swiper-button-white swiper-button-prev-false1" slot="button-prev"></div>

    <tx-img-template-app :options="options" :toIndex="index" class="template_swiper"></tx-img-template-app>
  </div>
</template>
<script>
import txImgTemplateApp from "@/common/tx-img-template-app";
export default {
  name: "tx-image-app",
  props: {
    //接收图片资源
    images: {
      type: Array,
      default: []
    }
  },
  data() {
    const self = this;
    return {
      show_big_button:false,//放大镜显隐
      index: 0, //轮播索引
      options: {
        show: false,
        list: []
      },
      //大图控件
      swiperOptionTop: {
        // effect:'fade',
        spaceBetween: 10,
        loop: true,
        loopedSlides: 5, //looped slides should be the same
        //自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: ".swiper-button-next-false1",
          prevEl: ".swiper-button-prev-false1"
        },
        on: {
          slideChangeTransitionEnd: function() {
            self.index = this.realIndex;
          }
        },
        grabCursor: true //允许手抓滑动
      }
      // //小图控件
      // swiperOptionThumbs: {
      //   spaceBetween: 10,
      //   slidesPerView: 5,
      //   centeredSlides: true,
      //   // slidesPerView: 'auto',
      //   touchRatio: 0.2,
      //   loop: true,
      //   loopedSlides: 5, //looped slides should be the same
      //   slideToClickedSlide: true,
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   },
      //   on: {
      //     slideChangeTransitionEnd: function() {
      //       self.index = this.realIndex;
      //     }
      //   }
      // }
    };
  },
  components: {
    txImgTemplateApp
  },
  mounted() {
    this.$nextTick(() => {
      const swiperTop = this.$refs.swiperTop.swiper;
      // const swiperThumbs = this.$refs.swiperThumbs.swiper;
      // swiperTop.controller.control = swiperThumbs;
      // swiperThumbs.controller.control = swiperTop;
    });
  },
  methods: {
    detail() {
      this.options.show = true;
      this.toIndex = "";
      this.toIndex = this.index;
      this.options.list = this.images;
    }
  },
  watch:{
    options:{
      handler(){
        if(this.options.show){
          this.$refs.swiperTop.swiper.autoplay.stop()
        }else{
          this.$refs.swiperTop.swiper.autoplay.start()
        }
      },
      deep:true
    }
  }
};
</script>
<style lang="scss" scoped>
.images {
  position: relative;
  .swiper-container {
    background-color: #000;
    z-index: 999;
  }
  >>> .swiper-wrapper {
    width: 96.5%;
  }
  .swiper-slide {
    background-size: cover;
    background-position: center;
    border-radius: 26px;
    height: 100% !important;
  }
  .center_text {
    width: 100%;
    height: 40px;
    margin: 3% auto;
    background: url("//txwl.huohuoche.com/txws/new_images_one/stories/text_bg.png")
      no-repeat center;
    background-size: cover;
    p {
      font-size: $fontSize_22;
      font-family: PingFang SC;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 40px;
      text-align: center;
    }
  }
  .mac {
    width: 357px;
    height: 702px;
    border: 1px solid rgba(00, 00, 00, 0);
    margin: 0 auto;
    position: relative;
    .phone {
      position: absolute;
      top:2px;
      width: 100%;
      height: 100%;
      background: url("//txwl.huohuoche.com/txws/new_images_one/stories/iphoneX.png")
        no-repeat center;
      background-size: cover;
      z-index:10000;
      pointer-events: none;
    }
    .show_big{
      width: 86%;
      height: 97%;
      position: absolute;
      top: 2%;
      left: 7%;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      pointer-events: none;
      z-index: 10000;
      border-radius: 30px;
      img {
        width: 16%;
      }
    }
  }
  .img{
    width:95%;
    display: block;
    margin:0 auto;
  }
  .gallery-top {
    height: 97% !important;
    width: 90%;
    margin-top: 5%;
    border-radius: 10px;
  }
  .gallery-thumbs {
    height: 22% !important;
    box-sizing: border-box;
    padding: 10px 0;
    margin-top: 2%;
    width: 88%;
  }
  .gallery-thumbs .swiper-slide {
    width: 20% !important;
    height: 100%;
    opacity: 0.4;
  }
  .gallery-thumbs .swiper-slide-active {
    opacity: 1;
  }

  .swiper-button-prev-false1 {
    width: 70px;
    height: 70px;
    position: absolute;
    left: -3%;
    top: 41%;
  }
  .swiper-button-next-false1 {
    width: 70px;
    height: 70px;
    position: absolute;
    right: -3%;
    top: 41%;
  }

  .swiper-button-prev-false1:focus,
  .swiper-button-next-false1:focus {
    outline: none !important;
  }

  .template_swiper {
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10000;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>


// WEBPACK FOOTER //
// src/common/tx-image-app.vue